import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ShoppingBag: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--shopping-bag')}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M21.1497662,8.98572868 L28,9 L28,25 L4,25 L4,8.95 L10.5650096,8.9636771 C11.2988129,5.58831043 13.0297121,3.52 15.855,3.52 C18.6864354,3.52 20.4187143,5.59732095 21.1497662,8.98572868 Z M19.6065703,8.98251369 C18.9819169,6.4620837 17.7132983,5.02 15.855,5.02 C14.0005448,5.02 12.7333328,6.45612521 12.1073134,8.96689024 L19.6065703,8.98251369 Z M10.3143108,10.4631581 L5.5,10.4531283 L5.5,23.5 L26.5,23.5 L26.5,10.4968783 L21.3984949,10.4862501 C21.5032373,11.3527643 21.555,12.2838548 21.555,13.27 L20.055,13.27 C20.055,12.2612405 19.9981885,11.3292783 19.8859065,10.4830989 L11.8263303,10.4663081 C11.7125661,11.3169447 11.655,12.2545637 11.655,13.27 L10.155,13.27 C10.155,12.275089 10.207687,11.3362157 10.3143108,10.4631581 Z"
        id="Shopping_Bag"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default ShoppingBag;
